export enum DmpFormatEnum {
  "Document texte brut" = 1,
  "Document RichText au format RTF" = 2,
  "Image au format JPEG" = 3,
  "Image au format TIFF" = 4,
  "Document au format PDF" = 5,
  "Volet de synthèse médicale" = 6,
  "Compte rendu de biologie" = 7,
  "Dossier de liaison d'urgence. Admission en EHPAD." = 40,
  "Dossier de liaison d'ugence. Transfert de l'EHPAD vers les urgences." = 41,
  "Dossier de liaison d'urgence. Retour des urgences vers l'EHPAD." = 42,
  "Certificat de santé du 9ème mois" = 83,
  "Certificat de santé du 24ème mois" = 84,
  "Carnet de santé de l'enfant - Mesures de l'enfant" = 68,
}
